import React, { useEffect, useState } from 'react';
import { OfferPackage } from './components/offer-package/offer-package';
import { useTranslation } from "react-i18next";
import PackageAPI from '../../axios/package';
import { PanelIcon } from '../user-panel/user-panel';

export const AdvertismentOfferPage = () => {
    const { t, i18n } = useTranslation(["offers"]);
    const lang = i18n.language;
    const [groups, setGroups] = useState([]);
    const [selectedGroup, setSelectedGroup] = useState(1);
    const [packageList, setPackageList] = useState([]);
    const [loaded, setLoaded] = useState(false);
    const [selected, setSelected] = useState(1);

    useEffect(() => {
        PackageAPI.getPackageGroups(lang).then(response => setGroups(response.data)).catch(err => console.log(err));
    }, [lang]);

    useEffect(() => {
        PackageAPI.getPackageList(selectedGroup, lang).then(response => {
            setPackageList(response.data);
            setLoaded(true);
        }).catch(err => console.log(err));
    }, [selectedGroup, lang]);

    if (loaded && groups.length === 0 && packageList.length === 0) {
        return (
            <section className='hs hs-panel-card hs-panel-empty'>
                <span className='hs-panel-empty-icon'><PanelIcon name='chart' size={24} /></span>
                <h2>{t("no_packages")}</h2>
                <p>{t("no_packages_text")}</p>
            </section>
        );
    }

    return (
        <section className='hs hs-panel-page wide'>
            <p className='hs-panel-lead'>{t("subtitle")}</p>
            <div className='hs-panel-tabs' role='tablist'>
                {groups.map(item => (
                    <button key={`offer-group-${item.id}`} role='tab' aria-selected={item.id === selectedGroup}
                        className={item.id === selectedGroup ? 'on' : ''} onClick={() => setSelectedGroup(item.id)}>{item.name}</button>
                ))}
            </div>
            <div className='hs-panel-packages'>
                {packageList.map((item, index) => (
                    <OfferPackage key={`package-${item.id}`} item={item} selected={index === selected} onSelect={() => setSelected(index)} />
                ))}
            </div>
            <span className='hs-panel-row-sub'>{t("vat")}</span>
        </section>
    );
};
